import type { Directive } from 'vue'

type Element = HTMLElement & {
  __alreadyClicked?: boolean
  __handler?: (event: Event) => void
}

export const vOneClick: Directive<Element, (event: Event) => any> = {
  mounted(el, binding) {
    const handler = binding.value;

    const oneHandler = async (event: Event) => {
      if (el.__alreadyClicked) {
        return ;
      }

      el.__alreadyClicked = true;
      (el as HTMLButtonElement).disabled = true;

      try {
        await handler?.(event);
      } catch (err) {
        (el as HTMLButtonElement).disabled = false;
        el.__alreadyClicked = false;
      }
    }

    el.__handler = oneHandler;
    el.addEventListener('click', oneHandler);
  },

  unmounted(el) {
    if (el.__handler) {
      el.removeEventListener('click', el.__handler);
    }
  }
}